export const VIEW_BREAKPOINTS = {
  "narrowPhone": 360,
  "phone": 480,
  "tablet": 768,
  "laptop": 1024,
  "desktop": 1440,
  "ultrawide": 1920
} as const;

export type ViewBreakpointName = keyof typeof VIEW_BREAKPOINTS;

export function getViewBreakpointWidth(name: ViewBreakpointName): number {
  return VIEW_BREAKPOINTS[name];
}

export function getViewBreakpointName(width: number): ViewBreakpointName {
  if (width <= VIEW_BREAKPOINTS.narrowPhone) {
    return "narrowPhone";
  }

  if (width <= VIEW_BREAKPOINTS.phone) {
    return "phone";
  }

  if (width <= VIEW_BREAKPOINTS.tablet) {
    return "tablet";
  }

  if (width <= VIEW_BREAKPOINTS.laptop) {
    return "laptop";
  }

  if (width <= VIEW_BREAKPOINTS.desktop) {
    return "desktop";
  }

  return "ultrawide";
}
